export let Success="Success"
export let Get="get"